export default "__VITE_ASSET__DHhqI66k__"